module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("74alk"))).then(() => parcelRequire('d0iPb'));